import { AlertTriangle } from "lucide-react";

// Only rendered when the site is running in a non-indexed preview environment.
// Flip REACT_APP_ALLOW_INDEXING=true in .env for production and this vanishes.
export default function PreviewBanner() {
  if (process.env.REACT_APP_ALLOW_INDEXING === "true") return null;

  return (
    <div
      data-testid="preview-env-banner"
      role="status"
      aria-label="Test environment notice"
      className="fixed top-0 inset-x-0 z-[70] h-8 bg-[#E60000] text-white text-[10px] md:text-[11px] tracking-[0.22em] uppercase font-bold flex items-center"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 flex items-center justify-center gap-2.5 text-center w-full">
        <AlertTriangle className="w-3 h-3 md:w-3.5 md:h-3.5 shrink-0" strokeWidth={2.5} />
        <span className="leading-none">
          Test Environment · Not Live · Client Review Only
        </span>
      </div>
    </div>
  );
}
